
/**
 * @roxi/routify 2.18.11
 * File generated Wed Jul 09 2025 11:10:08 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.11"
export const __timestamp = "2025-07-09T11:10:08.060Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports
import __topicId from '../src/pages/[topicId].svelte'
import _auth_extension_index from '../src/pages/auth/extension/index.svelte'
import _auth_extension_login from '../src/pages/auth/extension/login.svelte'
import _auth_index from '../src/pages/auth/index.svelte'
import _auth_login from '../src/pages/auth/login.svelte'
import _auth_logout from '../src/pages/auth/logout.svelte'
import _auth__reset from '../src/pages/auth/_reset.svelte'
import _copilot_index from '../src/pages/copilot/index.svelte'
import _copilot__reset from '../src/pages/copilot/_reset.svelte'
import _inbox_index from '../src/pages/inbox/index.svelte'
import _index from '../src/pages/index.svelte'
import _intro_index from '../src/pages/intro/index.svelte'
import _intro__reset from '../src/pages/intro/_reset.svelte'
import _payment_index from '../src/pages/payment/index.svelte'
import _pdf__pdfLink from '../src/pages/pdf/[pdfLink].svelte'
import _pdf_index from '../src/pages/pdf/index.svelte'
import _pdf_RecentDocuments_DeleteDocumentDialog from '../src/pages/pdf/RecentDocuments/DeleteDocumentDialog.svelte'
import _pdf_RecentDocuments_DocumentItem from '../src/pages/pdf/RecentDocuments/DocumentItem.svelte'
import _pdf_RecentDocuments_RecentDocuments from '../src/pages/pdf/RecentDocuments/RecentDocuments.svelte'
import _pdf__reset from '../src/pages/pdf/_reset.svelte'
import _print__topicId from '../src/pages/print/[topicId].svelte'
import _print__reset from '../src/pages/print/_reset.svelte'
import _v__topicId from '../src/pages/v/[topicId].svelte'
import _v_SharedTopicWrapper from '../src/pages/v/SharedTopicWrapper.svelte'
import _v__reset from '../src/pages/v/_reset.svelte'
import _welcome_index from '../src/pages/welcome/index.svelte'
import _welcome__reset from '../src/pages/welcome/_reset.svelte'
import __layout from '../src/pages/_layout.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isPage": true,
      "path": "/:topicId",
      "id": "__topicId",
      "component": () => __topicId
    },
    {
      "isDir": true,
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/auth/extension/index",
              "id": "_auth_extension_index",
              "component": () => _auth_extension_index
            },
            {
              "isPage": true,
              "path": "/auth/extension/login",
              "id": "_auth_extension_login",
              "component": () => _auth_extension_login
            }
          ],
          "path": "/auth/extension"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/auth/index",
          "id": "_auth_index",
          "component": () => _auth_index
        },
        {
          "isPage": true,
          "path": "/auth/login",
          "id": "_auth_login",
          "component": () => _auth_login
        },
        {
          "isPage": true,
          "path": "/auth/logout",
          "id": "_auth_logout",
          "component": () => _auth_logout
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/auth",
      "id": "_auth__reset",
      "component": () => _auth__reset
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/copilot/index",
          "id": "_copilot_index",
          "component": () => _copilot_index
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/copilot",
      "id": "_copilot__reset",
      "component": () => _copilot__reset
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/inbox/index",
          "id": "_inbox_index",
          "component": () => _inbox_index
        }
      ],
      "path": "/inbox"
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/intro/index",
          "id": "_intro_index",
          "component": () => _intro_index
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/intro",
      "id": "_intro__reset",
      "component": () => _intro__reset
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/payment/index",
          "id": "_payment_index",
          "component": () => _payment_index
        }
      ],
      "path": "/payment"
    },
    {
      "isDir": true,
      "children": [
        {
          "isPage": true,
          "path": "/pdf/:pdfLink",
          "id": "_pdf__pdfLink",
          "component": () => _pdf__pdfLink
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/pdf/index",
          "id": "_pdf_index",
          "component": () => _pdf_index
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/pdf/RecentDocuments/DeleteDocumentDialog",
              "id": "_pdf_RecentDocuments_DeleteDocumentDialog",
              "component": () => _pdf_RecentDocuments_DeleteDocumentDialog
            },
            {
              "isPage": true,
              "path": "/pdf/RecentDocuments/DocumentItem",
              "id": "_pdf_RecentDocuments_DocumentItem",
              "component": () => _pdf_RecentDocuments_DocumentItem
            },
            {
              "isPage": true,
              "path": "/pdf/RecentDocuments/RecentDocuments",
              "id": "_pdf_RecentDocuments_RecentDocuments",
              "component": () => _pdf_RecentDocuments_RecentDocuments
            }
          ],
          "path": "/pdf/RecentDocuments"
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/pdf",
      "id": "_pdf__reset",
      "component": () => _pdf__reset
    },
    {
      "isDir": true,
      "children": [
        {
          "isPage": true,
          "path": "/print/:topicId",
          "id": "_print__topicId",
          "component": () => _print__topicId
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/print",
      "id": "_print__reset",
      "component": () => _print__reset
    },
    {
      "isDir": true,
      "children": [
        {
          "isPage": true,
          "path": "/v/:topicId",
          "id": "_v__topicId",
          "component": () => _v__topicId
        },
        {
          "isPage": true,
          "path": "/v/SharedTopicWrapper",
          "id": "_v_SharedTopicWrapper",
          "component": () => _v_SharedTopicWrapper
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/v",
      "id": "_v__reset",
      "component": () => _v__reset
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/welcome/index",
          "id": "_welcome_index",
          "component": () => _welcome_index
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/welcome",
      "id": "_welcome__reset",
      "component": () => _welcome__reset
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => __layout
}


export const {tree, routes} = buildClientTree(_tree)

